export type WhatsAppAccountInfoMessages = {
  loadingAccountInfo: string;
  noDataFound: string;
  whatsappLabel: string;
  noNumberFound: string;
  profileAltText: string;
  openConversationsLabel: string;
  attendantActiveLabel: string;
  attendantInactiveLabel: string;
};

export const WHATSAPP_ACCOUNT_INFO_MESSAGES: WhatsAppAccountInfoMessages = {
  loadingAccountInfo: "Carregando informações da conta...",
  noDataFound: "Nenhum dado encontrado",
  whatsappLabel: "WhatsApp:",
  noNumberFound: "Nenhum número encontrado",
  profileAltText: "Usuário",
  openConversationsLabel: "Conversas em aberto:",
  attendantActiveLabel: "Ativo",
  attendantInactiveLabel: "Inativo",
};
